import React from "react";
import { PriceDisplay } from "../Products/PriceDisplay";
import { AttributeOption } from "../Products/types";

export type SelectorOptionProps = {
  Option: AttributeOption;
  isSelected: boolean;
  onChange: () => void;
  DisplayZero: string;
  groupName: string;
};

export const SelectorOption: React.FC<SelectorOptionProps> = ({
  Option,
  isSelected,
  onChange,
  DisplayZero,
  groupName,
}) => {
  const optionClass = `selector-option ${isSelected ? "option-selected" : ""}`;

  const uniqueId = `${groupName}-${Option.Id}`;


  return (
    <>
      <input 
        type="radio" 
        id={uniqueId} 
        name={groupName} 
        checked={isSelected}
        onChange={onChange}/>

      <label 
        className={optionClass} 
        htmlFor={uniqueId}>
          <div className="option-info flex-1">
        <p className="option-info__qty flex-1">
        {Option.IconUrl && (
          <img
            className="fancy-selector__img"
            src={Option.IconUrl}
            alt={Option.Name}
          ></img>
        )}
          {Option.Name}
        </p>
        <p className="option-info__price">
          <PriceDisplay opt={Option} displayZero={DisplayZero}></PriceDisplay>
        </p>
        {isSelected && Option.Description && (
          <div
            className="fun-facts flex flex-column"
            dangerouslySetInnerHTML={{ __html: Option.Description }}
          ></div>
        )}
        </div>
      </label>
    </>
  );
};
